import { getSignUpAuth } from '@/config/auth';
import throwClientError from './helpers/throwClientError';
export default async function signUp(email, password, profile) {
    try {
        const username = email.toLowerCase();
        await getSignUpAuth().signUp({
            username,
            password,
            attributes: {
                ...profile,
                'custom:provider:name': 'basic',
                email: username,
            },
        });
        return {};
    }
    catch (error) {
        return throwClientError(error);
    }
}
